import { __ } from "@wordpress/i18n";
import { RawHTML, useEffect } from "@wordpress/element";
import {
  useBlockProps,
  InnerBlocks,
  InspectorControls,
  ColorPalette,
} from "@wordpress/block-editor";
import {
  __experimentalHeading as Heading,
  PanelBody,
  __experimentalUnitControl as UnitControl,
  __experimentalNumberControl as NumberControl,
  GradientPicker,
} from "@wordpress/components";
import bannerImage from "/public/img/Frame-19.png";
import frame1 from "/public/img/Frame1.png";

export const edit = ({ clientId, attributes, setAttributes }) => {
  const {
    id,
    menuItemNum,
    megaMenuInnerWidth,
    megaMenuBGcolor,
    megaMenuLinkCurrentColor,
    megaMenuDropdownColor,
    megaMenuDropdownHoverColor,
    megaMenuGradientBG,
  } = attributes;

  useEffect(() => {
    if (!id) {
        // Set unique ID through block index only once.
        let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
        setAttributes({ id: 'hfcmm-' + clientIdSliced });
    }
  }, [id, clientId, setAttributes]);

  // Defined Block Props.
  const blockProps = useBlockProps();

  const ALLOWED_BLOCKS = [
    "core/group",
    "core/columns",
    "core/column",
    "core/list",
    "core/list-item",
    "core/image",
    "core/heading",
    "core/paragraph",
  ];

  const TEMPLATE = [
    [
      "core/group",
      {
        className: "hfc-mm-4",
      },
      [
        [
          "core/columns",
          {
            verticalAlignment: "center",
            className: "hfc-mm-cols-first",
          },
          [
            [
              "core/column",
              {
                width: "25%",
                className: "hfc-mm-col",
              },
              [
                [
                  "core/cover",
                  {
                    url: `${bannerImage}`,
                    dimRatio: 20,
                    className: "hfc-cover-wrapper",
                  },
                  [
                    [
                      "core/image",
                      {
                        url: `${frame1}`,
                        className: "hfc-mega-menu-banner",
                      },
                    ],
                    [
                      "core/heading",
                      {
                        level: 2,
                        content: "Managed SEO",
                      },
                    ],
                    [
                      "core/paragraph",
                      {
                        content:
                          "Reach your ranking goals faster with our comprehensive SEO management solutions, starting today for guaranteed success.<br><br>Let us help boost your online visibility and drive targeted organic traffic effectively to your site consistently.",
                      },
                    ],
                    [
                      "core/button",
                      {
                        text: "View Pricing ➔",
                        url: "#",
                        content: "View Pricing",
                      },
                    ],
                  ],
                ],
              ],
            ],

            [
              "core/column",
              {
                width: "25%",
                className: "hfc-mm-col",
              },
              [
                [
                  "core/heading",
                  {
                    level: 5,
                    content: "SEO Services",
                    className: "custom-heading-one",
                  },
                ],
                [
                  "hfc-blocks/icon-list",
                  {},
                  [
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Professional SEO ➔",
                        icon: "faMagnifyingGlassChart",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "SaaS SEO ➔",
                        icon: "faMagnifyingGlassChart",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "eCommerce SEO ➔",
                        icon: "faMagnifyingGlassChart",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Shopify SEO ➔",
                        icon: "faMagnifyingGlassChart",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Webflow SEO ➔",
                        icon: "faMagnifyingGlassChart",
                        isLinkable: true
                      },
                    ],
                  ],
                ],

                [
                  "core/heading",
                  {
                    level: 5,
                    content: "SEO Backlinks",
                    className: "custom-heading-two",
                  },
                ],
                [
                  "hfc-blocks/icon-list",
                  {},
                  [
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "HARO Backlinks ➔",
                        icon: "faArrowUpRightFromSquare",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Outreach Backlinks ➔",
                        icon: "faArrowUpRightFromSquare",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Sponsored Post ➔",
                        icon: "faArrowUpRightFromSquare",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "ABC Backlinks ➔",
                        icon: "faArrowUpRightFromSquare",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "PR Backlinks ➔",
                        icon: "faArrowUpRightFromSquare",
                        isLinkable: true
                      },
                    ],
                  ],
                ],
              ],
            ],

            [
              "core/column",
              {
                width: "25%",
                className: "hfc-mm-col",
              },
              [
                [
                  "core/heading",
                  {
                    level: 5,
                    content: "Video Editing",
                    className: "custom-heading-three",
                    isLinkable: true
                  },
                ],
                [
                  "hfc-blocks/icon-list",
                  {
                    hfcIconBgColor: "#29375c",
                    hfcIconBgHoverColor: "#29375c",
                    isLinkable: true
                  },
                  [
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Explainer Video Editing ➔",
                        icon: "faFilm",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "SaaS Product Video ➔",
                        icon: "faFilm",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Promotional Video ➔",
                        icon: "faFilm",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Reel Video Editing ➔",
                        icon: "faFilm",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Long Video Editing ➔",
                        icon: "faFilm",
                        isLinkable: true
                      },
                    ],
                  ],
                ],

                [
                  "core/heading",
                  {
                    level: 5,
                    content: "AI & Writing Services",
                    className: "custom-heading-four",
                  },
                ],
                [
                  "hfc-blocks/icon-list",
                  {
                    hfcIconBgColor: "#29375c",
                    hfcIconBgHoverColor: "#29375c",
                  },
                  [
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "WP AI Automation ➔",
                        icon: "faRobot",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "AI Writing Services ➔",
                        icon: "faRobot",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Shopify AI Content ➔",
                        icon: "faRobot",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Copy Writing Services ➔",
                        icon: "faRobot",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Product Review Writing ➔",
                        icon: "faRobot",
                        isLinkable: true
                      },
                    ],
                  ],
                ],
              ],
            ],

            [
              "core/column",
              {
                width: "25%",
                className: "hfc-mm-col",
              },
              [
                [
                  "core/heading",
                  {
                    level: 5,
                    content: "Development",
                    className: "custom-heading-five",
                  },
                ],
                [
                  "hfc-blocks/icon-list",
                  {},
                  [
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "WP Development Services ➔",
                        icon: "faCode",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "SaaS Development ➔",
                        icon: "faCode",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "WP Plugin Development ➔",
                        icon: "faCode",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "WP Maintenance Services ➔",
                        icon: "faCode",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Theme Development ➔",
                        icon: "faCode",
                        isLinkable: true
                      },
                    ],
                  ],
                ],
                [
                  "core/heading",
                  {
                    level: 5,
                    content: "Content Marketing",
                    className: "custom-heading-six",
                  },
                ],
                [
                  "hfc-blocks/icon-list",
                  {},
                  [
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Blog Content Creation ➔",
                        icon: "faChartSimple",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Social Media Content ➔",
                        icon: "faChartSimple",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Infographic Design ➔",
                        icon: "faChartSimple",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Email Marketing Content ➔",
                        icon: "faChartSimple",
                        isLinkable: true
                      },
                    ],
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: "Case Study Creation ➔",
                        icon: "faChartSimple",
                        isLinkable: true
                      },
                    ],
                  ],
                ],
              ],
            ],
          ],
        ],

        [
          "core/columns",
          {
            verticalAlignment: "center",
            className: "hfc-mm-cols-second",
          },
          [
            [
              "core/column",
              {
                width: "50%",
                className: "hfc-mm-col",
              },
              [
                [
                  "core/paragraph",
                  {
                    content:
                      'Not sure where to start? <a href="#">Chat with us</a>',
                  },
                ],
              ],
            ],

            [
              "core/column",
              {
                width: "50%",
                className: "hfc-mm-col",
              },
              [
                [
                  "core/paragraph",
                  {
                    content: "Free Guide",
                  },
                ],
                [
                  "hfc-blocks/icon-list",
                  {},
                  [
                    [
                      "hfc-blocks/list-item",
                      {
                        spanText: '<a href="tel:+8801625192766">+880 162-519-2766</a>',
                        icon: "faPhone",
                        isLinkable: true,
                        url: 'tel:+880 162-519-2766'
                      },
                    ],
                  ],
                ],
              ],
            ],
          ],
        ],
      ],
    ],
  ];

  const hfcmmDynamicStyles = `#${id}.hfc-mega-menu {
        background-color: ${megaMenuBGcolor};
        border-radius: 10px;
        box-shadow: 0px 13px 34px 0px rgba(0, 0, 0, 0.35);
        position: relative;
        z-index: 0;
        width: ${megaMenuInnerWidth};
        margin: 0 auto;
    }
    .wp-block-hfc-blocks-mega-menu-4{
        margin-top: 0px!important;
    }
   .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label,
   .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label,
   .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label{
        position: relative;
        line-height: 30px;
        display: block;
    }
    .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after,
    .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after,
    .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 5px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${megaMenuDropdownColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after{
        border-color: ${megaMenuDropdownHoverColor};
    }
    .editor-styles-wrapper .wp-block-group__inner-container {
        padding: 0px!important;
    }
    .editor-styles-wrapper .block-editor-block-list__block{
        max-width: 100%!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first{
        display: flex;
        align-items: flex-start!important;
        gap: 10px;
        padding: 40px 0px 30px 20px;
     }
     #${id} .hfc-mm-4 h5{
        font-size: 14px;
        text-transform: uppercase;
        font-weight: bold;
        margin-bottom: 10px!important;
     }
     #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col:first-child{
        margin-right: 15px;
     }
     #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col:first-child .hfc-cover-wrapper{
        min-height: 300px;
        height: auto;
        padding: 30px;
        border-radius: 20px;
        margin-top: 0;
    }
    #${id} .hfc-mm-4 .hfc-mm-col h2,
    #${id} .hfc-mm-4 .hfc-mm-col p,
    #${id} .hfc-mm-4 .hfc-mm-col a{
        color: ${megaMenuLinkCurrentColor};
    }
    #${id} .hfc-mm-4 .hfc-mm-col h2{
       font-size: 32px;
       font-weight: bold;
       margin: 0;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-one{
       color: #3E598B;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-two{
       color: #649BB2;
       margin-top: 35px!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-three{
       color: #E1982B;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-four{
       color: #478064;
       margin-top: 35px!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-five{
       color: #B54069;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-six{
       color: #2e2e8f;
       margin-top: 35px!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col p{
       font-size: 14px;
       line-height: 1.5;
       margin: 15px 0!important;
       color: #C8C8C8;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col .wp-block-button,
    #${id} .hfc-mm-4 .hfc-mm-col p,
    #${id} .hfc-mm-4 .wp-block-hfc-blocks-icon-list{
        margin: 0!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col .wp-block-button .wp-block-button__link{
        padding: 10px 20px;
        border-radius: 10px;
        position: relative;
        color: #ffffff;
        background-color: #f35d36;
        line-height: 24px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-icon-list-main .fp-ip-inner{
        padding: 0px!important;
    }
    #${id} .hfc-mm-cols-second .hfc-icon-list-main .fp-ip-inner span{
        color: #ffffff!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second{
        background: ${megaMenuGradientBG};
        padding: 30px;
        border-radius: 0 0 10px 10px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col:first-child a{
        text-decoration: underline;
     }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-icon-list-main .fp-ip-inner{
        background-color: transparent!important;
    } 
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col a,
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col p{
        font-weight: bold;
        font-size: 16px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col{
        display: flex;
        align-items: center;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col:last-child{
        justify-content: flex-end;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .fp-ip-inner{
        gap: 10px;
        pointer-events: none;
    }
    @media (min-width: 599px) and (max-width: 1200px){
    #${id} .hfc-mm-4 .hfc-mm-cols-first{
         flex-direction: column!important;
         align-items: unset !important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second {
        display: flex;
        flex-direction: column !important;
        gap: 0px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col{
       justify-content: center;
    }
    #${id}.hfc-mega-menu .hfc-mm-4{
        width: max-content!important;
    }
    #${id} .hfc-mm-4 h5 {
        margin-top: 30px !important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col:last-child {
        gap: 0px !important;
        flex-direction: column;
    }
     #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col .wp-block-hfc-blocks-list-item {
        gap: 5px !important;
    }
    }
     @media (max-width: 1024px){
     /* Reset */
    h1,h2{font-size: 28px!important;}
    /* Mega Menu */
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col:first-child .hfc-cover-wrapper{
        padding: 45px 15px!important;
      }
    }
    @media (max-width: 599px) {
    #${id}.hfc-mega-menu{
        left: 0!important;
        right: 0;
        transform: none!important;
        z-index: 9!important;
        overflow-y: auto;
        max-height: 500px;
        height: auto;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
        border-radius: 0px 0px 10px 10px;
    }
    #${id}.hfc-mega-menu .hfc-mm-4{
        width: 100%!important;
        margin-top: 0!important;
        border-radius: 0!important;
    }
    #${id} .hfc-mm-4 h5{
        margin-top: 30px!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first,
    #${id} .hfc-mm-4 .hfc-mm-cols-second{
        display: flex;
        flex-direction: column!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col{
        display: flex;
        flex-direction: column!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .wp-block-cover__inner-container{
       z-index: 1!important;
     }
    }
    /* Edit Page Compatibility */
    .editor-styles-wrapper .wp-block-cover__inner-container .hfc-mega-menu-banner{
        margin: 0;
    } 
    .editor-styles-wrapper .hfc-mm-4,
    .editor-styles-wrapper .hfc-mm-4 .hfc-mm-cols{
       max-width: 100%;
    }
    .editor-styles-wrapper .hfc-mm-4 .block-editor-block-list__block{
      padding: 0px;
    }
    .editor-styles-wrapper .hfc-mm-4 .wp-block-group__inner-container{
        max-width: 100%!important;
    }`;

  return [
    <InspectorControls key={`inspector-controls-${id}`}>
      <PanelBody
        title={__("Mega Menu-04 Settings")}
        icon={"admin-generic"}
        initialOpen={true}
        className={"frhd__control frhd__control-query"}
      >
        <NumberControl
          label={__("Menu Item Number")}
          isShiftStepEnabled={true}
          onChange={(newValue) => setAttributes({ menuItemNum: newValue })}
          shiftStep={1}
          value={menuItemNum}
        />
        <UnitControl
          label={__("Mega Menu Inner Width :")}
          onChange={(newValue) =>
            setAttributes({ megaMenuInnerWidth: newValue })
          }
          isUnitSelectTabbable
          value={megaMenuInnerWidth}
          className={"frhd__component frhd__component-width-90"}
        />
        <Heading className={"frhd__pb-heading"}>
          Mega Menu Background Color :
        </Heading>
        <ColorPalette
          value={megaMenuBGcolor}
          onChange={(colorValue) =>
            setAttributes({ megaMenuBGcolor: colorValue })
          }
          clearable={false}
        />
        <Heading className={"frhd__pb-heading"}>Dropdown Color :</Heading>
        <ColorPalette
          value={megaMenuDropdownColor}
          onChange={(colorValue) =>
            setAttributes({ megaMenuDropdownColor: colorValue })
          }
          clearable={false}
        />
        <Heading className={"frhd__pb-heading"}>
          Dropdown Hover Color :
        </Heading>
        <ColorPalette
          value={megaMenuDropdownHoverColor}
          onChange={(colorValue) =>
            setAttributes({ megaMenuDropdownHoverColor: colorValue })
          }
          clearable={false}
        />
        <Heading className={"frhd__pb-heading"}>Bottom Background :</Heading>
        <GradientPicker
          value={megaMenuGradientBG}
          onChange={(currentGradient) =>
            setAttributes({ megaMenuGradientBG: currentGradient })
          }
        />
      </PanelBody>
    </InspectorControls>,
    <div {...blockProps} key={`${id}-main-blocks`}>
      <RawHTML>{`<style>${hfcmmDynamicStyles}</style>`}</RawHTML>
      <div id={id} className={"hfc-mega-menu"}>
        <InnerBlocks allowedBlocks={ALLOWED_BLOCKS} template={TEMPLATE} />
      </div>
    </div>,
  ];
};

export const save = ({ attributes }) => {
  const {
    id,
    menuItemNum,
    megaMenuInnerWidth,
    megaMenuBGcolor,
    megaMenuLinkCurrentColor,
    megaMenuDropdownColor,
    megaMenuDropdownHoverColor,
    megaMenuGradientBG,
  } = attributes;

  const hfcmmDynamicStyles = `#${id}.hfc-mega-menu {
        display: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 0;
        top: 25px;
    }
    .hfc-main-header-2 #${id}.hfc-mega-menu{
        left: unset !important;
        transform: unset !important;
        right: 0;
        top: 50% !important;
    }
    #${id}.hfc-mega-menu .hfc-mm-4{
        background-color: ${megaMenuBGcolor};
        border-radius: 10px;
        box-shadow: 0px 13px 34px 0px rgba(0, 0, 0, 0.35);
        margin-top: 25px;
        width: ${megaMenuInnerWidth};
        padding: 0px!important;
    }
     #${id} .hfc-mm-4 .hfc-icon-list-main{
        margin: 0;
     } 
    #${id} .hfc-main-header-3 .hfc-mm-4 .hfc-mm-col {
        display: flex;
        flex-direction: column;
    }
    #${id} .hfc-mm-4 .hfc-mm-col p,
    #${id} .hfc-mm-4 .hfc-mm-col a{
        margin: 0!important;
        color: ${megaMenuLinkCurrentColor};
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label{
        position: relative;
        line-height: 30px;
        display: block;
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 5px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${megaMenuDropdownColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after{
        border-color: ${megaMenuDropdownHoverColor};
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col:first-child{
        margin-right: 15px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col:first-child .hfc-cover-wrapper{
        min-height: 300px;
        height: auto;
        padding: 30px;
        border-radius: 20px;
        margin-top: 0;
    }
     #${id} .hfc-mm-4 .hfc-mm-cols-first{
       padding: 40px 0px 30px 20px;
       display: flex;
       align-items: flex-start!important;
       gap: 10px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col h2{
        color: ${megaMenuLinkCurrentColor};
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col p{
        color: #C8C8C8;
    }
     #${id} .hfc-mm-4 .hfc-mm-col h2{
       font-size: 32px;
       font-weight: bold;
       margin: 0;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-one{
       color: #3E598B;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-two{
       color: #649BB2;
       margin-top: 35px!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-three{
       color: #E1982B;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-four{
       color: #478064;
       margin-top: 35px!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-five{
       color: #B54069;
    }
    #${id} .hfc-mm-4 .hfc-mm-col .custom-heading-six{
       color: #2e2e8f;
       margin-top: 35px!important;
    }
     #${id} .hfc-mm-4 h5{
        font-size: 14px;
        text-transform: uppercase;
        font-weight: bold;
        margin-bottom: 10px!important;
     }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col p{
       font-size: 14px;
       line-height: 1.5;
       margin: 15px 0!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col .wp-block-button,
    #${id} .hfc-mm-4 .wp-block-hfc-blocks-icon-list{
        margin: 0;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col .wp-block-button .wp-block-button__link{
        padding: 10px 20px;
        border-radius: 10px;
        line-height: 24px;
        position: relative;
        color: #ffffff;
        background-color: #f35d36;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-icon-list-main .fp-ip-inner{
        padding: 0px!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second{
        background: ${megaMenuGradientBG};
        padding: 30px;
        border-radius: 0 0 10px 10px;
    }
     #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col:first-child a{
        text-decoration: underline;
     }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col a,
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col p{
        font-weight: bold;
        font-size: 16px;
     }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col{
        display: flex;
        align-items: center;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col:last-child{
        justify-content: flex-end;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col .fp-ip-inner,
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col .wp-block-hfc-blocks-list-item{
        gap: 0px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col .fp-ip-inner{
       pointer-events: none;
       background-color: transparent!important;
    }
    #${id} .hfc-mm-cols-second .hfc-icon-list-main .fp-ip-inner span{
        color: #ffffff!important;
    }
    @media (min-width: 599px) and (max-width: 1200px){
    #${id} .hfc-mm-4 .hfc-mm-cols-first{
         flex-direction: column!important;
         align-items: unset !important;
    }
     #${id} .hfc-mm-4 .hfc-mm-cols-second {
        display: flex;
        flex-direction: column !important;
        gap: 0px;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col{
       justify-content: center;
    }
    #${id}.hfc-mega-menu .hfc-mm-4{
        width: max-content!important;
    }
    #${id} .hfc-mm-4 h5 {
        margin-top: 30px !important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col:last-child {
        gap: 0px !important;
        flex-direction: column;
    }
     #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col .wp-block-hfc-blocks-list-item {
        gap: 5px !important;
    }
    }
     @media (max-width: 1024px){
     /* Reset */
    h1,h2{font-size: 28px!important;}
     #${id} .hfc-mm-4 .hfc-mm-cols-first .hfc-mm-col:first-child .hfc-cover-wrapper{
        padding: 45px 15px!important;
      }
    }
    @media (max-width: 599px) {
    #${id}.hfc-mega-menu{
        left: 0!important;
        right: 0;
        transform: none!important;
        z-index: 9!important;
        overflow-y: auto;
        max-height: 500px;
        height: auto;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
        border-radius: 0px 0px 10px 10px;
    }
    #${id}.hfc-mega-menu .hfc-mm-4{
        width: 100%!important;
        margin-top: 0!important;
        border-radius: 0!important;
    }
    #${id} .hfc-mm-4 h5{
        margin-top: 30px!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-first,
    #${id} .hfc-mm-4 .hfc-mm-cols-second{
        display: flex;
        flex-direction: column!important;
    }
    #${id} .hfc-mm-4 .hfc-mm-cols-second .hfc-mm-col{
        display: flex;
        flex-direction: column!important;
    }
     #${id} .hfc-mm-4 .hfc-mm-cols-first .wp-block-cover__inner-container{
       z-index: 1!important;
     }
    }`;

  return (
    <>
      <RawHTML>{`<style>${hfcmmDynamicStyles}</style>`}</RawHTML>
      <div
        id={id}
        data-menu-item-number={menuItemNum}
        className={"hfc-mega-menu"}
      >
        <InnerBlocks.Content />
      </div>
    </>
  );
};
